import Icon from '../icons/icon';
import Text from '../typography/v2/text';
import { HStack } from '../layouts/stack.layout';
import { Link } from 'react-router-dom';
import { PATH } from '../../constants';

const styles = {
  'link-wrapper':
    'h-[74px] w-full  hover:bg-[#1c1c1c] py-3 px-2.5 ease-in duration-150',
};

type ExpandedSearchContainerProps = {
  value: string;
};

export default function ExpandedSearchContainer({
  value,
}: ExpandedSearchContainerProps) {
  return (
    <Link
      to={`/${PATH.DISCOVER}?q=${value}`}
      className={styles['link-wrapper']}
    >
      <HStack gap="base" extensions="items-center h-full">
        <Icon icon="search" />
        <HStack gap="xs" extensions="items-center">
          <Text>search for</Text>
          <Text variant="navigation">"{value}"</Text>
        </HStack>
      </HStack>
    </Link>
  );
}
